import { render } from "./page8.vue?vue&type=template&id=6c548b70&scoped=true"
import script from "./page8.vue?vue&type=script&lang=js"
export * from "./page8.vue?vue&type=script&lang=js"

import "./page8.vue?vue&type=style&index=0&id=6c548b70&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/carbon-space-admin-site-CI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c548b70"]])

export default __exports__